'use strict';

var React = require('react');

var SvgSnapchatMinor = function SvgSnapchatMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.907 7.292c-.113-1.671-.702-3.792-3.765-3.792s-3.651 2.12-3.765 3.792c-.04.597-.502.92-1.1.949-.31.015-1.093-.377-1.093.134 0 1.083 2.166 1.083 2.166 2.167 0 1.083-1.625 2.708-2.708 3.25-1.083.541.344.713 1.083 1.083.74.37 1.018 1.466 2.167 1.083 1.15-.383 2.167.542 3.25.542 1.083 0 2.101-.925 3.25-.542 1.15.383 1.427-.713 2.167-1.083.74-.37 2.166-.542 1.083-1.083-1.083-.542-2.708-2.167-2.708-3.25 0-1.084 2.166-1.084 2.166-2.167 0-.51-.782-.119-1.093-.134-.598-.03-1.06-.352-1.1-.949Z"
  }));
};
SvgSnapchatMinor.displayName = "SnapchatMinor";

exports.SvgSnapchatMinor = SvgSnapchatMinor;
